import { render, staticRenderFns } from "./IconicButton.vue?vue&type=template&id=d2bad9c0"
import script from "./IconicButton.vue?vue&type=script&lang=js"
export * from "./IconicButton.vue?vue&type=script&lang=js"
import style0 from "./IconicButton.vue?vue&type=style&index=0&id=d2bad9c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports